import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTimezone } from 'helpers/post';
import { get } from 'lodash';
import Job from './Job';
import { convertToMilitaryFormat } from 'helpers/dashboard';

class JobsForShift extends Component {
  render() {
    const { jobs, shift, pendingApplicants, from, isOpen, rateTypes, jobsMetadata, eventTitle } =
      this.props;

    const order = [
      'pending',
      'eo_accepted_at',
      'confirmed',
      'checked_in',
      'paid',
      'waitlist',
      'callout',
      'eo_removed_at',
      'no_show',
    ];

    if (!jobs.length && isOpen && from === 'upcoming') {
      this.props.handleExpand();
      return null;
    }

    const orderedJobs = jobs.sort((a, b) => {
      const stateOrder = order.indexOf(a.currentState) - order.indexOf(b.currentState);
      if (stateOrder !== 0) {
        return stateOrder;
      }
      return a.createdAt - b.createdAt;
    });

    return (
      <div className="shift-jobs">
        <div className="row shift-jobs-headers">
          <div className="col-3">AT NAME</div>
          <div className="col-2">STATUS</div>
          <div className="col-5">ACTION</div>
          <div className="col-2">ADD’L INFO</div>
        </div>

        {orderedJobs.map((job) => {
          const allApplied = get(jobsMetadata, `[${job.id}].appliedToAllShiftsLocation`, false);

          return (
            <Job
              key={job.id}
              job={job}
              pendingApplicants={pendingApplicants}
              shift={shift}
              from={from}
              rateTypes={rateTypes}
              allApplied={allApplied}
              eventTitle={eventTitle}
              shifts={this.props.shifts}
              session={this.props.session}
            />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const tz = getTimezone(ownProps.shift.eventLocation);
  const jobs = ownProps.jobs;
  const updatedJobs = convertToMilitaryFormat(jobs, tz)

  return {
    pendingApplicants: state.user.pendingApplicants,
    jobsMetadata: state.dashboard.applicants.jobsMetadata,
    jobs: updatedJobs,
    rateTypes: state.enums.rateTypes,
    session: state.session,
  };
};

export default connect(mapStateToProps)(JobsForShift);
